import { onMounted, onBeforeUnmount } from 'vue';
import events, { type Events } from '@/events';

export function useEventListener<Key extends keyof Events>(eventName: Key, callback: (eventData: Events[Key]) => void) {
  onMounted(() => {
    events.on(eventName, callback);
  });

  onBeforeUnmount(() => {
    events.off(eventName, callback);
  });
}
